console.log("called"); 
let product_on_page = $('.product-on-page');
let next_url = product_on_page('next-url');

function loadMoreProducts(){
$.ajax(
  {
  url:('next-url'),
  type: 'GET',
  dataType: 'html'
}
).done(function(next_page){
  let new_products = $(next_page).find('.product-on-page');
  let new_url = new_products.data('next-url');

  next_url = new_url;

  product_on_page.append(new_products.html());
})
}